import axios from 'axios';
import apiConfig from '../../api.config';

export default async function getHBXAggregatorChannels() {
  const {
    host,
    URIs: { hbxChannels },
  } = apiConfig;

  const uri = `${host}${hbxChannels}`;

  return await axios.get(uri).then(res => res.data);
}
